import { GET_HMA_ITEMS, GET_HRV_ITEMS, GET_IODINE_TEST_ITEMS, GET_IRCOMBI_ITEMS } from '../../services/graphql/queries/professional';
import { useMutation, useQuery } from '@apollo/client';
import { useCallback } from 'react';
import { PROFESSIONAL_TOGGLE_CLIENT_VIEWABLE } from '../../services/graphql/mutations/professional';

export const useGetClientIrCombiItems = (clientId: string) => {
  const { data, loading, refetch } = useQuery(GET_IRCOMBI_ITEMS, {
    variables: {
      clientId
    }
  });

  const fetchClientIrCombiItems = useCallback(() => {
    if (data) {
      return data.clientIrCombiItems;
    }
  }, [data]);

  return {
    data: data?.clientIrCombiItems,
    fetchData: fetchClientIrCombiItems,
    loading,
    refetch
  };
};

export const useGetHRVItems = (clientId: string) => {
  const { data, loading, refetch } = useQuery(GET_HRV_ITEMS, {
    variables: {
      clientId
    }
  });

  const fetchClientHRVItems = useCallback(() => {
    if (data) {
      return data.clientHrvItems;
    }
  }, [data]);

  return {
    data: data?.clientHrvItems,
    fetchData: fetchClientHRVItems,
    loading,
    refetch
  };
};

export const useGetHMAItems = (clientId: string) => {
  const { data, loading, refetch } = useQuery(GET_HMA_ITEMS, {
    variables: {
      clientId
    }
  });

  const fetchClientHMAItems = useCallback(() => {
    if (data) {
      return data.clientHmaItems;
    }
  }, [data]);

  return {
    data: data?.clientHmaItems,
    fetchData: fetchClientHMAItems,
    loading,
    refetch
  };
};

export const useGetIodineTestItems = (clientId: string) => {
  const { data, loading, refetch } = useQuery(GET_IODINE_TEST_ITEMS, {
    variables: {
      clientId
    }
  });

  const fetchClientIodineTestItems = useCallback(() => {
    if (data) {
      return data.clientIodineTestItems;
    }
  }, [data]);

  return {
    data: data?.clientIodineTestItems,
    fetchData: fetchClientIodineTestItems,
    loading,
    refetch
  };
};

export const useToggleClientViewable = () => {
  const [mutate, { loading }] = useMutation(PROFESSIONAL_TOGGLE_CLIENT_VIEWABLE);

  const toggleClientViewable = async (clientId: string, analysesId: string, analysesType: string, authToken?: string) => {
    try {
      const res = await mutate({
        variables: {
          input: {
            clientId,
            analysesId,
            analysesType
          }
        },
        context: authToken ? {
          headers: {
            Authorization: `Bearer ${authToken}`
          }
        } : undefined,
        update: (cache, { data }) => {
          if (data?.toggleClientViewable) {
            const { analysesId, isViewable, analysesType } = data.toggleClientViewable;

            // Map analysesType to Typename
            const typeMap: Record<string, string> = {
              hma: 'HairAndMineral',
              hrv: 'HeartRateVariability',
              ir_combi: 'IrCombi',
              iodine: 'IodineTest'
            };

            const typename = typeMap[analysesType];
            if (typename) {
              cache.modify({
                id: cache.identify({ __typename: typename, id: analysesId }),
                fields: {
                  clientViewable() {
                    return isViewable;
                  }
                }
              });
            }
          }
        }
      });
      return res.data;
    } catch (error) {
      console.error('toggleClientViewable error', error);
      throw error;
    }
  };

  return {
    toggleClientViewable,
    loading
  };
};